import { ethers } from 'ethers';

// Polygon chains (mainnet + testnets) require a high minimum priority fee (25+ gwei)
const POLYGON_MAINNET_IDS = new Set([137]);
const POLYGON_TESTNET_IDS = new Set([80001, 80002]);

/**
 * Get EIP-1559 gas overrides that meet network minimum requirements.
 * Polygon chains (mainnet + testnets) require a minimum priority fee of 30 gwei.
 * Other chains use the network's own fee data as-is.
 * @param {ethers.providers.Provider} provider
 * @param {number} multiplier - Multiplier for fee data (default 2x)
 * @returns {Object} Gas overrides to spread into contract calls
 */
export async function getGasOverrides(provider, multiplier = 2) {
  try {
    const { chainId } = await provider.getNetwork();
    const feeData = await provider.getFeeData();
    const overrides = {};

    if (feeData.maxFeePerGas) {
      // EIP-1559 chain
      let minPriorityFee = null;
      if (POLYGON_MAINNET_IDS.has(chainId)) {
        minPriorityFee = ethers.utils.parseUnits('30', 'gwei');
      } else if (POLYGON_TESTNET_IDS.has(chainId)) {
        minPriorityFee = ethers.utils.parseUnits('30', 'gwei');
      }

      const priorityFee = feeData.maxPriorityFeePerGas
        ? feeData.maxPriorityFeePerGas.mul(multiplier)
        : (minPriorityFee || feeData.maxFeePerGas.div(2));

      overrides.maxPriorityFeePerGas = minPriorityFee && priorityFee.lt(minPriorityFee)
        ? minPriorityFee
        : priorityFee;
      overrides.maxFeePerGas = feeData.maxFeePerGas.mul(multiplier);

      if (overrides.maxFeePerGas.lt(overrides.maxPriorityFeePerGas)) {
        overrides.maxFeePerGas = overrides.maxPriorityFeePerGas.mul(2);
      }
    }

    return overrides;
  } catch (err) {
    console.warn('Failed to get fee data, using defaults:', err.message);
    return {};
  }
}
